/**
 * Single source of truth for notification-type → emoji icon
 * mapping. Used by every layout's notification drawer
 * (DesktopLayout, MobileLayout, TabletLayout, CapacitorLayout) so
 * adding a new notification type only needs one edit, not four.
 *
 * Falls back to 🔔 when the type isn't recognized.
 *
 * Why a tiny module instead of inlining: notifications are added
 * incrementally over time, and the drift problem (icon shows in
 * desktop but not in capacitor because someone forgot to update
 * one) was already happening — drinks_* notifications had no
 * icons in any layout. Centralizing fixes that going forward.
 */

export const NOTIF_TYPE_ICONS = {
  // Game / roster lifecycle
  reminder:             '📅',
  spare_request:        '🙋',
  arena_change:         '🚨',
  new_message:          '💬',
  chat:                 '💬',
  rsvp_response:        '✅',
  teams_balanced:       '⚖️',
  rebalance_needed:     '⚖️',
  game_result:          '🏆',
  player_added:         '👥',
  system:               '⚙️',
  day_before:           '📅',
  hours_before:         '⏰',
  roster_locked:        '🔒',
  availability_changed: '🔄',

  // Drinks duty (Apr 2026)
  drinks_assigned:       '🥤',
  drinks_volunteer:      '🥤',
  drinks_unassigned:     '🥤',
  drinks_stepped_down:   '🥤',
  drinks_day_before:     '🥤',
  drinks_hours_before:   '🥤',
  drinks_scheduled:      '🥤',
  drinks_reminder:       '🥤',
  drinks_reminder_soon:  '🥤',

  // Payments
  payment_request:    '💳',
  payment_received:   '💰',
  payment_confirmed:  '💰',

  // Coach-only operational alerts
  coach_alert:                  '⚠️',

  // Coach overrides (Apr 2026)
  free_play_granted:            '🎁',

  // Waitlist auto-management (Apr 2026)
  waitlist_auto_released:        '🎟',
  waitlist_auto_promoted_below:  '🎟',
  low_attendance_alert:          '⚠️',
};

/** Look up the icon for a notification type, with 🔔 fallback. */
export function iconForNotifType(type) {
  return NOTIF_TYPE_ICONS[type] || '🔔';
}
